import { render } from "./KafedraYuklamalari.vue?vue&type=template&id=13953f14&scoped=true"
import script from "./KafedraYuklamalari.vue?vue&type=script&lang=js"
export * from "./KafedraYuklamalari.vue?vue&type=script&lang=js"

import "./KafedraYuklamalari.vue?vue&type=style&index=0&id=13953f14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13953f14"]])

export default __exports__